
import EnCustomer from "../images/en/customer.png"
import enLogo1 from "../images/en/logo1.png"
import enLogo7 from "../images/en/logo7.png"
import enLogo8 from "../images/en/logo8.png"
import enLogo3 from "../images/en/logo3.png"
import enLogo6 from "../images/en/logo6.png"
import enLogo9 from "../images/en/logo9.png"
import enLogo12 from "../images/en/logo12.png"



import { UserLogoMapType, UserLogoMapMobileType } from 'globalCommon/utils/index'

export const UserLogoMap: UserLogoMapType = {

    en: EnCustomer,
    em: EnCustomer,


};

/* CN/TW 移动端用横向滚动 logo 列表，EN/EM/JP 仍沿用桌面单图 */
export const UserLogoMapMobile: UserLogoMapMobileType = {

};

/* about-us-cn 专用：全部站点移动端都用滚动 logo 列表（不像 security/enterprise 只有 CN/TW） */
export const UserLogoMapMobileAll: UserLogoMapMobileType = {

    en: [enLogo1, enLogo7, enLogo8, enLogo3, enLogo6, enLogo9, enLogo12],
    em: [enLogo1, enLogo7, enLogo8, enLogo3, enLogo6, enLogo9, enLogo12],


};
